/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components';

interface StatusProps {
  status?: 'A' | 'I' | 'B' | 'D';
}

const StatusVariations = {
  A: css`
    background: var(--green);
  `,
  I: css`
    color: var(--purple);
    background: var(--gray-line);
  `,
  B: css`
    background: var(--red);
  `,

  D: css`
    background: var(--orange);
  `,
};

export const FormWrapper = styled.div`
  width: 100%;
  Form {
    margin-top: 20px;
  }

  input {
    height: 40px;
  }
  .btn-wrapper {
    margin-top: 30px;
    display: flex;
    width: 100%;
    button {
      width: inherit;
    }

    .btn-cancelar {
      color: #757575;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      margin-right: 20px;
    }
  }
  .bloqueados {
    margin-bottom: 60px;
  }
`;

export const ModalContent = styled.div`
  height: 250px;
  width: 600px;
  padding: 0px 15px 30px 15px;
  text-align: center;
  p {
    padding-bottom: 10px;
  }
`;

export const LinkModal = styled.a`
  text-decoration: underline;
  color: var(--purple) !important;
  width: 50px;
  height: auto;
  cursor: pointer;
  :hover {
    color: var(--orange)
  }
  padding-right: 5px;
`;

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
  }

  .TitleContainer {
    margin-top: 13px;
    align-items: center;
    justify-content: space-between;
    @media only screen and (max-width: 768px) {
      margin-top: -25px;
      justify-content: center;
    }
  }

  .info {
  }
`;

export const Title = styled.h1`
  align-items: center;
  justify-content: space-between;

  .title {
    width: 100%;
    font-size: 45px;
    color: var(--orange);
    display: flex;
    justify-content: space-between;
    @media only screen and (max-width: 768px) {
      justify-content: center;
      flex-direction: column-reverse;
    }
  }

  .card {
    color: var(--purple);
  }
  @media only screen and (max-width: 768px) {
    justify-content: center;
    text-align: center;
  }
`;

export const ButtonsContainer = styled.h1`
  margin: 30px 0 30px 170px;
  .buttonsInitial {
    display: flex;
    justify-content: flex-end;
    button {
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      transition: background 0.3s ease;
    }
    .extrato {
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
    }
    .saldo {
      border: 2px solid var(--purple);
      color: var(--purple);
      background-color: transparent;
      &:hover {
        background: var(--purple);
        color: var(--white);
      }
    }
    @media only screen and (max-width: 768px) {
      margin-top: 30px;
      margin-left: 125px;
      justify-content: center;
    }
    @media only screen and (max-width: 767px) {
      margin-top: 190px;
      margin-left: 0px;
      justify-content: center;
    }
  }
  @media only screen and (max-width: 769px) {
    margin-left: 0px;
    justify-content: center;
  }
`;

export const SubTitle = styled.h3`
  color: var(--purple);
  font-size: 20px;
`;

export const DataContainer = styled.div`
  h1 {
    color: var(--orange);
  }
  h2 {
    color: var(--purple);
  }
`;

export const Card = styled.div`
  box-shadow: var(--box-shadow);
  margin-top: 5px;
  margin-bottom: 25px;
  padding: 90px;
  background: var(--aside-background);
  border-radius: 20px;

  @media only screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;

export const StatusRow = styled.div<StatusProps>`
  color: var(--white);
  width: 130px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  ${props => StatusVariations[props.status || 'A']}
`;

export const ButtonBlock = styled.div`
  display: flex;
  justify-content: center;
  width: 70%;
  margin-top: 70px;
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--orange);
    background-color: transparent;
    border: 1px solid #c5d0d6;
    border-radius: 17px;
    width: 100%;
    border: 2px solid var(--orange);
    height: 40px;
    font-weight: 600;
    p {
      margin-left: 15px;
    }
  }
  @media only screen and (max-width: 1024px) {
    justify-content: left;
    width: 100%;
  }
`;
